import React from 'react'
import { FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { PrimaryButton } from '../../atoms/primaryButton/PrimaryButton'
import { BodyTextSize } from '../../styles/typeStyles'

const Container = styled.View(({ theme }) => ({
  padding: theme.spacing['24px'],
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing['16px'],
}))

const ClearFiltersButton = styled(PrimaryButton)({
  alignSelf: 'center',
})

type ConversationListEmptyProps = {
  hasFilters: boolean
  onClearFiltersPressed: () => void
}

export const ConversationListEmpty: React.FC<ConversationListEmptyProps> = ({ hasFilters, onClearFiltersPressed }) => {
  const { colors } = useTheme()
  return (
    <Container>
      <BodyText
        size={BodyTextSize.LARGE}
        color={colors.textSecondary}
        textAlign='center'
        text={
          hasFilters ? (
            <FormattedMessage
              defaultMessage='No matching conversations, remove filters to see more.'
              description='No conversations found for selected filters'
            />
          ) : (
            <FormattedMessage
              defaultMessage='No conversations available.'
              description='No conversations found for provider'
            />
          )
        }
      />
      {hasFilters && (
        <ClearFiltersButton
          text={<FormattedMessage defaultMessage='Clear filters' description='Clear filters button' />}
          onPress={onClearFiltersPressed}
        />
      )}
    </Container>
  )
}
